import { Navigate } from "react-router";

import { useInfosecFeatureEnabled } from "~/hooks";
import { routes } from "~/routes";
import { firstAllowedAdminPath, useSession } from "~/session";

/** /admin lands on the first tenant-surface page the caller may open, the same target a refused guard uses. */
export function AdminIndexRedirect() {
  const session = useSession();
  const infosecEnabled = useInfosecFeatureEnabled();
  if (session.isLoading) return null;
  return <Navigate to={firstAllowedAdminPath(session, infosecEnabled, "tenant") ?? routes.AdminUsers} replace />;
}
